export const LOGO_LIST_REQUEST = 'LOGO_LIST_REQUEST'
export const LOGO_LIST_SUCCESS = 'LOGO_LIST_SUCCESS'
export const LOGO_LIST_FAIL = 'LOGO_LIST_FAIL'

